import { VStack } from '@ayble-health/dashboard-components';
import React from 'react';
import { Separator } from '@chakra-ui/react';
import { UserProfile } from './UserProfile';
import { UserInformation } from '../HealthCoachDashboard/UserInformation';
import { MeetingNotes } from '../HealthCoachDashboard/MeetingNotes';
import styled from '@emotion/styled';
import { UserDashboardSideContentAction } from './UserDashboardSideContentAction';
import { UpcomingMeeting } from './UpcomingMeeting';
import { UserSubscription } from './UserSubscription';
import { UserCareTeam } from './UserCareTeam';
import { useDashboardPageState } from '../../hooks/useDashboardPageState';
import { getIntercomConversationsUrl } from '../../constants/misc';

const GradientBox = styled('div')`
  background-image: linear-gradient(to bottom, #ffffff, #ebf5ff, #ebf5ff);
`;

type Props = {
  openHealthieCharting: (chartingNoteUrl?: string | null) => void;
};

export const UserDashboardSideContent = ({ openHealthieCharting }: Props) => {
  const {
    state: { user },
  } = useDashboardPageState();

  const intercomId = user?.intercom_id;

  const openIntercomConversations = () => {
    if (!intercomId) return;

    window.open(
      getIntercomConversationsUrl(intercomId),
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <GradientBox>
      <VStack height={'100%'} p={6}>
        <UserProfile />

        <UpcomingMeeting
          onOpenChartNote={(chartingNoteUrl) => {
            openHealthieCharting(chartingNoteUrl);
          }}
        />

        <VStack gap={2} alignItems={'stretch'} mb={3}>
          <UserDashboardSideContentAction
            onClick={() => {
              openHealthieCharting();
            }}
            text={'Charting'}
          />

          <UserDashboardSideContentAction
            disabled={!intercomId}
            onClick={openIntercomConversations}
            text={'Message Patient'}
          />
        </VStack>

        <UserInformation />

        <UserCareTeam />

        <Separator mb={3} mt={8} />

        <UserSubscription />

        <Separator mb={3} mt={8} />

        <MeetingNotes onOpenChartNote={openHealthieCharting} />
      </VStack>
    </GradientBox>
  );
};
